import React from "react";
import type { BoxProps } from "@chakra-ui/react";
import { Box } from "@chakra-ui/react";

interface BlurWrapperProps extends BoxProps {
  blurContent?: boolean;
  children: React.ReactNode;
  blurStyle?: React.CSSProperties; // Optional prop for custom blur style
}

export const BlurWrapper: React.FC<BlurWrapperProps> = ({ blurContent = false, children, blurStyle, ...props }) => {
  if (!blurContent) {
    return <Box {...props}>{children}</Box>;
  }

  return (
    <Box position="relative" {...props} pointerEvents="none" p="1px">
      {children}
      <Box
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="0"
        backdropFilter="blur(4px)"
        backgroundColor="rgba(255, 255, 255, 0.1)"
        borderRadius="md"
        zIndex="10"
        pointerEvents="auto"
        sx={blurStyle}
        display="flex"
        alignItems="center"
        justifyContent="center"
      />
    </Box>
  );
};
